export const SET_PROXIMITY_SELECTION = 'SET_PROXIMITY_SELECTION';
export const UPDATE_PROXIMITY_SELECTION = 'UPDATE_PROXIMITY_SELECTION';
export const RESET_PROXIMITY_SELECTION = 'RESET_PROXIMITY_SELECTION';
export const SET_LAST_APPLIED_PROXIMITY = 'SET_LAST_APPLIED_PROXIMITY';
